import api from './axios';

const list = async () => {
  try {
    const { data } = await api.get('mcare-artemis-advertising-delivery/partners');
    return data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    throw error.response.data ? error.response.data : error.response;
  }
};

const update = async (advertisingPartner) => {
  try {
    const { data } = await api.put(
      `mcare-artemis-advertising-delivery/partners/${advertisingPartner.id}`,
      advertisingPartner,
    );
    return data;
  } catch (error) {
    const { status } = error.response;
    const message = status === 400
      ? 'Verifique os campos obrigatórios'
      : 'Houve um problema ao salvar o Fornecedor';
    throw new Error(message);
  }
};

export default {
  list,
  update,
};
